export default function ErrorScreen({ message }) {

    return (
        <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: '#ff0000',
            fontSize: '1.2em',
            fontFamily: 'Arial, sans-serif',
            textAlign: 'center',
            padding: '20px'
        }}>
            Error loading the model: {message}
        </div>
    );
}
